import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import AtlasV2PaidTrafficV2PaidTrafficSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2PaidTrafficV2/AtlasV2PaidTrafficV2PaidTrafficSplineChart';
import AtlasV2PaidTrafficKeywordCountWithPaidTraffic from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2PaidTrafficV2/AtlasV2PaidTrafficKeywordCountWithPaidTraffic';
import AtlasV2PaidTrafficV2ShareOfTrafficSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2PaidTrafficV2/AtlasV2PaidTrafficV2ShareOfTrafficSplineChart';
import AtlasV2PaidTrafficV2ProductsWithTraffic from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2PaidTrafficV2/AtlasV2PaidTrafficV2ProductsWithTraffic';
import AtlasV2PaidTrafficDoubleDropdownTopEntity from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2PaidTrafficV2/AtlasV2PaidTrafficDoubleDropdownTopEntity';
import AtlasV2PaidTrafficV2AdSpendSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2PaidTrafficV2/AtlasV2PaidTrafficV2AdSpendSplineChart';
import {
  useBrandEntity,
  useBusinessUnitEntity,
  useCategoryEntity,
  useProductEntity,
  useSegmentEntity,
  useSubcategoryEntity
} from 'src/utils/Hooks/reduxSelectors';
import AtlasV2TotalFilterableStackedBarChart from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TotalFilterableStackedBarChart';
import { AtlasV2TrafficProductGrid } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TrafficV2ProductGrid';
import AtlasV2FilterableStackedBarChart from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TotalFilterableStackedBarChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import AtlasV2TotalTrafficV2BrandedUnbrandedSplineChart from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TrafficV2BrandedUnbrandedSplineChart';
import { shouldShowBrandUnbranded } from 'src/utils/app';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';
/**
 * Atlas V2 Paid Traffic V2 Page layout - Tab name: traffic subtab name: adClicks
 */
export const AtlasV2PaidTrafficV2PageLayout = () => {
  const { isCategoryEntity, isAllCategoriesEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();
  const { isSegmentEntity } = useSegmentEntity();
  const { isBusinessUnitEntity } = useBusinessUnitEntity();
  const { isBrandEntity } = useBrandEntity();
  const { isProductEntity } = useProductEntity();
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <AtlasV2PaidTrafficV2PaidTrafficSplineChart />
        <AtlasV2PaidTrafficV2AdSpendSplineChart />
        <AtlasV2PaidTrafficV2ShareOfTrafficSplineChart />

        {!isProductEntity && (
          <>
            <AtlasV2PaidTrafficDoubleDropdownTopEntity />
            <AtlasV2PaidTrafficV2ProductsWithTraffic />
          </>
        )}

        <AtlasV2PaidTrafficKeywordCountWithPaidTraffic />

        {/* Branded/ Unbranded SpineChart Traffic */}
        {(isCategoryEntity || isSubcategoryEntity || isSegmentEntity || isBusinessUnitEntity) &&
          shouldShowBrandUnbranded() && <AtlasV2TotalTrafficV2BrandedUnbrandedSplineChart fieldName="adClicks" />}

        {(isCategoryEntity || isSubcategoryEntity || isSegmentEntity || isBusinessUnitEntity) && (
          <AtlasV2TotalFilterableStackedBarChart
            metricDropdownOptions={[
              {
                id: 'adClicks',
                label: 'Paid Search Traffic',
                apiMetricFieldName: 'adClicks'
              },
              {
                id: 'adSpend',
                label: 'Paid Search Spend',
                apiMetricFieldName: 'adSpend',
                metricTypeDisplay: METRICTYPE.MONEY
              },
              {
                id: 'percentTraffic',
                label: '% of Paid Search Traffic',
                apiMetricFieldName: 'adClicks',
                isPercentageVisible: true,
                defaultMetric: 'adClicks'
              },
              {
                id: 'percentSpend',
                label: '% of Paid Search Spend',
                apiMetricFieldName: 'adSpend',
                isPercentageVisible: true,
                defaultMetric: 'adSpend'
              }
            ]}
            groupByFieldOptions={[
              {
                id: 'keyword',
                label: 'Keyword'
              }
            ]}
          />
        )}

        {isBrandEntity && (
          <AtlasV2PaidTrafficDoubleDropdownTopEntity
            groupByFields={[
              { id: 'category', label: 'Category', indexName: 'traffic' },
              { id: 'subcategory', label: 'Subcategory', indexName: 'traffic' }
            ]}
          />
        )}

        {(isCategoryEntity || isSegmentEntity || isBusinessUnitEntity) && (
          <AtlasV2FilterableStackedBarChart
            metricDropdownOptions={[
              {
                id: 'adClicks',
                label: 'Paid Search Traffic',
                apiMetricFieldName: 'adClicks',
                subtitleLabel: 'paid search traffic'
              },
              {
                id: 'adSpend',
                label: 'Paid Search Spend',
                apiMetricFieldName: 'adSpend',
                subtitleLabel: 'paid search spend',
                metricTypeDisplay: METRICTYPE.MONEY
              },
              {
                id: 'percentAdTraffic',
                label: '% of Paid Search Traffic',
                apiMetricFieldName: 'adClicks',
                isPercentageVisible: true,
                defaultMetric: 'adClicks',
                subtitleLabel: 'percentage of paid search traffic'
              },
              {
                id: 'percentAdSpend',
                label: '% of Paid Search Spend',
                apiMetricFieldName: 'adSpend',
                isPercentageVisible: true,
                defaultMetric: 'adSpend',
                subtitleLabel: 'percentage of paid search spend'
              }
            ]}
            groupByFieldOptions={[
              ...(isAllCategoriesEntity || isSegmentEntity || isBusinessUnitEntity
                ? [
                    {
                      id: 'category',
                      label: 'Category'
                    }
                  ]
                : []),
              {
                id: 'subcategory',
                label: 'Subcategory'
              }
            ]}
          />
        )}

        <AtlasV2TrafficProductGrid trafficType="adClicks" />
      </Flex>
    </BasePageContainer>
  );
};
